<template>
  <div class="survey">
    <status class="survey-status" />
    <div class="survey-content">
      <div
        class="gradients"
        :class="{ bottom: scrolledToBottom, top: scrolledToTop }"
      >
        <section
          v-if="answers"
          @scroll="checkScroll"
          :class="['step-scroll', step.data.slug]"
        >
          <transition name="fade-custom" mode="out-in">
            <div class="step-content" :key="$route.fullPath">
              <h2 class="h2">{{ step.data.label }}</h2>
              <p v-if="step.data.description">{{ step.data.description }}</p>
              <component
                :is="step.type"
                :data="step.data"
                v-model="answers[index]"
                @input="setAnswer"
              />
            </div>
          </transition>
        </section>
      </div>

      <section class="controls">
        <Button arrow="left" class="icoonly" @click="back" />
        <Progress />
        <Button arrow="right" class="blue" @click="next">Következő</Button>
      </section>
    </div>
  </div>
</template>

<script>
import Button from "@/components/inputs/Button.vue";

import Range from "@/components/inputs/Range.vue";
import Multirange from "@/components/inputs/Multirange.vue";
import Number from "@/components/inputs/Number.vue";
import Numselect from "@/components/inputs/Numselect.vue";
import Checkbox from "@/components/inputs/Checkbox.vue";
import Radio from "@/components/inputs/Radio.vue";

import Status from "@/components/Status.vue";
import Progress from "@/components/Progress.vue";

export default {
  name: "Survey",
  components: {
    Button,
    Range,
    Multirange,
    Number,
    Checkbox,
    Radio,
    Numselect,
    Status,
    Progress
  },
  data() {
    return {
      index: 0,
      steps: null,
      step: null,
      answers: null,
      scrolledToTop: true,
      scrolledToBottom: false
      // value: null,
    };
  },
  methods: {
    checkScroll(e) {
      this.scrolledToBottom =
        e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight;

      this.scrolledToTop = e.target.scrollTop === 0;
    },
    back() {
      if (this.steps[this.index - 1]) {
        this.index--;
      } else {
        this.$router.push("/");
      }
    },
    next() {
      if (this.steps[this.index + 1]) {
        this.index++;
      } else {
        this.$router.push("/kerdoiv/osszesito");
      }
    },
    setAnswer(value, key) {
      this.$store.commit("setAnswer", {
        index: this.$store.getters.getStepIndexBySlug(key),
        value: value
      });
    }
  },
  watch: {
    index() {
      this.$store.commit("setStepByIndex", this.index);
      if (this.steps[this.index].data.slug !== this.$route.params.step)
        this.$router.push("/kerdoiv/" + this.steps[this.index].data.slug);
    },
    /* $route(to, from) {
      console.log("to: ", to);
      console.log("from: ", from);
    } */
    $route() {
      //console.log("change route");
      // this.$store.commit("setStepByIndex", this.index);
      this.step = this.$store.getters.getStepBySlug(this.$route.params.step);
      this.index = this.$store.getters.getStepIndexBySlug(
        this.$route.params.step
      );
    }
  },
  mounted() {
    this.answers = this.$store.getters.getAnswers;
  },
  created() {
    // console.log("created", this.$route.params.step);
    this.$store.commit("setStepBySlug", this.$route.params.step);
    this.steps = this.$store.getters.getSteps;
    this.step = this.$store.getters.getStepBySlug(this.$route.params.step);
    this.index = this.$store.getters.getStepIndexBySlug(
      this.$route.params.step
    );
  }
};
</script>

<style lang="scss">
.survey {
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  padding-top: 20px;

  .survey-status {
    max-height: 550px !important;
  }

  .survey-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 600px;
    // height: calc(100% - 63px);
  }
  .gradients {
    position: relative;
    height: 100%;
    overflow-x: hidden;
    &.top {
      &:before {
        opacity: 0;
      }
    }
    &.bottom {
      &:after {
        opacity: 0;
      }
    }
    &:before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      z-index: 10;
      height: 10px;
      background: linear-gradient($lightgray, $transparent);
      transition: opacity 0.3s ease-in-out;
    }
    &:after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 10;
      height: 10px;
      background: linear-gradient($transparent, $lightgray);
      transition: opacity 0.3s ease-in-out;
    }
  }
  .step-scroll {
    position: relative;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    .step-content {
      display: flex;
      padding: 0 16px;
      width: calc(100% - 32px);
      min-height: calc(100% - 32px);
      flex-direction: column;
      justify-content: center;
      h2 {
        color: $black;
        max-width: 500px;
        // margin-bottom: 16px;
        // flex: 0 0 10%;
      }
      p {
        // flex: 0 0 1%;
        margin: 4px 0 12px;
        max-width: 480px;
      }
      .container {
        // height: 65%;
        height: 100%;
        width: 100%;
        flex-grow: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }
    }
  }
  .controls {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    padding: 0 16px 16px;
    // flex: 0 0 10%;
    .progress {
      padding-left: 0;
      padding-right: 0;
      width: 100%;
      // flex: 0 0 100%;
      order: 1;
    }

    .arrowleft {
      order: 2;
    }

    .arrowright {
      order: 3;
      width: calc(100% - 66px);
    }
  }
  @media screen and (min-width: $breakpoint) {
    padding-top: 64px;
    flex-direction: column;
    height: 100%;
    min-height: 550px;
    padding-top: 0;
    .survey-content {
      height: 100%;
      justify-content: space-between;
      /* height: fit-content; */
      height: 550px;
    }
    .step-scroll {
      -ms-overflow-style: none;
      scrollbar-width: none;
      scroll-behavior: auto;
      &::-webkit-scrollbar {
        display: none;
      }
      width: 100%;
      height: 100%;
      // flex: 0 0 70%;
      .step-content {
        padding: 0;
        padding: 24px 24px 24px 8px;
        // width: calc(100% - 40px);
        // height: calc(100% - 48px);
        height: 100%;
        width: 100%;
        box-sizing: border-box;
      }
    }
    .controls {
      display: flex;
      // width: 100%;
      padding: 0 24px 24px 8px;
      flex-wrap: nowrap;
      justify-content: flex-start;
      .progress {
        padding-left: 16px;
        padding-right: 16px;
        order: 2;
      }
      .arrowleft {
        order: 1;
      }

      .arrowright {
        order: 3;
        width: auto;
      }
    }

    .status {
      width: 100%;
      height: 100%;
    }
  }

  .fade-custom-enter-active,
  .fade-custom-leave-active {
    transition: opacity 0.5s;
  }
  .fade-custom-enter,
  .fade-custom-leave-to {
    opacity: 0;
  }
}
</style>
